/**
 * wim-stickyfill-shim.js
 * Shim no-op de Stickyfill.
 *
 * `position: sticky` es nativo en todos los navegadores objetivo (2026), así que
 * el polyfill Stickyfill se eliminó de `libs.min.js` (Fase 3a del ADR de rendimiento).
 * Pero `theme.min.js` (bundle nativo, no editable) sigue llamando a
 * `Stickyfill.addOne(el)` / `Stickyfill.removeOne(el)`. Sin el global esas llamadas
 * lanzarían ReferenceError y cortarían la ejecución del theme.
 *
 * Este shim expone `window.Stickyfill` con la API como no-ops: los elementos usan
 * `position: sticky` nativo y no hace falta ninguna gestión JS.
 *
 * Debe cargarse (defer) DESPUÉS de libs.min.js y ANTES de theme.min.js.
 */
(() => {
  'use strict';
  if (window.Stickyfill) return;
  const noop = () => {};
  window.Stickyfill = {
    addOne: noop,
    removeOne: noop,
    add: noop,
    remove: noop,
    init: noop,
    refreshAll: noop,
    stickies: []
  };
})();
